export default "__VITE_ASSET__Dn6kFH1$__"